export const num2name = {
    0: "STATUS_UNSPECIFIED",
    1: "STATUS_NOT_STARTED",
    2: "STATUS_ACTIVE",
    3: "STATUS_CANCELED",
    4: "STATUS_ACCOUNT_HOLD",
    5: "STATUS_EXPIRED",
};
export const name2num = {
    STATUS_UNSPECIFIED: 0,
    STATUS_NOT_STARTED: 1,
    STATUS_ACTIVE: 2,
    STATUS_CANCELED: 3,
    STATUS_ACCOUNT_HOLD: 4,
    STATUS_EXPIRED: 5,
};
